import { Injectable, inject } from "@angular/core";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { MarknadsprislistaDialogComponent } from "../marknadsprislista/marknadsprislista-dialog/marknadsprislista-dialog.component";
import { IHandelssortimentsgrupp } from "../models/marknadsprislista-model";
import { IMarknadsomradeMultiSelector } from "../models/verksamhetsomraden-models";

@Injectable({
    providedIn: "root"
})
export class MarknadsprislistaDialogService {
    private readonly modalService = inject(NgbModal);

    open(marknadsomrade: IMarknadsomradeMultiSelector[], handelssortimentGrupper: IHandelssortimentsgrupp[], prislista = null, callBack: (result: any) => void = null) {
        const options = {
            keyboard: false,
            backdrop: "static",
            size: "lg"
        } as NgbModalOptions;
        const modalRef = this.modalService.open(MarknadsprislistaDialogComponent, options);
        modalRef.componentInstance.prislista = prislista ? prislista : null;
        modalRef.componentInstance.marknadsomrade = marknadsomrade;
        modalRef.componentInstance.handelssortimentGrupper = handelssortimentGrupper;
        if (callBack) {
            modalRef.result.then(r => callBack(r));
        } else {
            modalRef.result.then(r => modalRef.close(r));
        }
    }

    beforeDismiss() {
        return false;
    }
}
